import React from 'react';

import { Box, Typography } from '@mui/material';

import {
  Reason,
  ReasonsTransform,
} from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { CriminalRecords } from '../../../../tasks/types/criminalRecords';
import { LabPiqture } from '../../../../tasks/types/labPiqture';
import { MedicalClaims } from '../../../../tasks/types/medicalClaims';
import { ScriptCheck } from '../../../../tasks/types/scriptCheck';

type TaskData = LabPiqture | MedicalClaims | ScriptCheck | CriminalRecords;

export const SimpleSummary = ({
  title,
  description,
  data,
}: {
  title: string;
  description: string;
  data: TaskData;
}) => {
  const transformedReasons: Reason[] = (data.reason || []).map(item => {
    return ReasonsTransform.getReason(item) as Reason;
  });

  return (
    <Box mt={5}>
      <Box>
        <Typography variant="h3">{title}</Typography>
      </Box>
      <Box mt={2}>
        <Typography variant="body1" gutterBottom>
          {Resource.DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">{description}</Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="body1">{Resource.ORDER_REASON}</Typography>
      </Box>
      <Box my={1} ml={1.75}>
        <ul style={{ padding: 0, margin: 0 }}>
          {transformedReasons.map(reason => (
            <li key={reason.key}>
              <Typography variant="body2">{reason.displayName}</Typography>
            </li>
          ))}
        </ul>
      </Box>
      <Box>
        <Typography variant="body2">{data.reasonDescription}</Typography>
      </Box>
    </Box>
  );
};
